export function isImageFile(path: string): boolean {
  return /\.(png|jpe?g|gif|bmp|webp|svg)$/i.test(path);
}
